'use client';

import { useEffect, useRef } from 'react';

export function useLatestRef<T>(value: T) {
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  return valueRef;
}
